module.exports = __webpack_public_path__ + "static/media/40-1.4697668b.mp3";